var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.sepa_core_collection") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          [
            _c(
              "b-row",
              {
                staticClass:
                  "min-w-100 justify-content-start align-items-center",
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "d-flex justify-content-start mt-3 mb-5",
                    attrs: { cols: "12" },
                  },
                  [
                    _c("back-button", {
                      staticClass: "btnFilter_2 mr-2 btn-back",
                      attrs: { returnUrl: _vm.returnUrl },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _vm.activateSpinner
                  ? _c("spinner")
                  : _c("div", { staticClass: "min-w-100" }, [
                      _vm.isReport
                        ? _c("div", { staticClass: "body" }, [
                            _c("div", [
                              _c("div", { staticClass: "font-weight-bold" }, [
                                _c("i", {
                                  staticClass: "icon fa fa-file",
                                  staticStyle: { "margin-right": "15px" },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("filter.nameFile") + " : ")
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.fileName ? _vm.fileName : "test.csv"
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "my-2 py-2 line-success" },
                                [
                                  _c("i", {
                                    staticClass: "icon fa fa-check",
                                    staticStyle: { "margin-right": "15px" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.results.ACCP) +
                                        " " +
                                        _vm._s(
                                          _vm.$t("company.fileLineAproove")
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "my-2 py-2 line-update" },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-envelope-dot",
                                    staticStyle: { "margin-right": "15px" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.results.UPDT) +
                                        " " +
                                        _vm._s(
                                          _vm.$t("company.fileLineUpdated")
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "my-2 py-2 line-warning" },
                                [
                                  _c("i", {
                                    staticClass: "icon fa fa-pencil",
                                    staticStyle: { "margin-right": "15px" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.results.EXST) +
                                        " " +
                                        _vm._s(
                                          _vm.$t("company.fileLineAlreadyExist")
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "my-2 py-2 line-error" },
                                [
                                  _c("i", {
                                    staticClass: "icon fa fa-times",
                                    staticStyle: { "margin-right": "15px" },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.results.RFSL) +
                                        " " +
                                        _vm._s(_vm.$t("company.fileLineReject"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex mt-3 justify-content-end" },
                        [
                          !_vm.isReport
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "inline-flex",
                                  attrs: { id: "btnFakeUpload" },
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "fake-import-button",
                                      attrs: { for: "image_uploads" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.fileName
                                            ? _vm.$t("company.fileReplace")
                                            : _vm.$t("company.fileChoose")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.fileName
                                    ? _c(
                                        "label",
                                        { attrs: { for: "image_uploads" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("company.fileNone"))
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "label",
                                        { attrs: { for: "image_uploads" } },
                                        [_vm._v(_vm._s(_vm.fileName))]
                                      ),
                                  _vm._v(" "),
                                  _c("input", {
                                    key: _vm.hiddenButtonKey,
                                    ref: "file",
                                    staticClass: "opacity-0",
                                    attrs: {
                                      type: "file",
                                      id: "image_uploads",
                                      accept: ".csv",
                                      multiple: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleFileUpload()
                                      },
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isReport
                            ? _c("div", { staticClass: "download" }, [
                                _c("div", { staticClass: "btn btn-primary" }, [
                                  _c(
                                    "a",
                                    { on: { click: _vm.downloadReport } },
                                    [
                                      _c("i", {
                                        staticClass: "icon fa fa-download",
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "download-report-text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "company.fileDownloadReport"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mb-5 col-lg-2 col-xl-2 col-4" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: { type: "button" },
                                  on: { click: _vm.cancel },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.isReport
                                          ? "OK"
                                          : _vm.$t("company.fileCancel")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isReport
                            ? _c(
                                "div",
                                { staticClass: "mb-5 col-lg-2 col-xl-2 col-4" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          _vm.fileContent === "" ||
                                          _vm.fileName === "" ||
                                          _vm.showLoader,
                                      },
                                      on: { click: _vm.send },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("company.fileSend")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }